import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { publicAPI } from '../services/apiService';
import DynamicCityPage from '../pages/DynamicCityPage';

const DynamicRouteHandler = () => {
  const { '*': fullPath } = useParams();
  const [loading, setLoading] = useState(true);
  const [validSlug, setValidSlug] = useState(null);

  useEffect(() => {
    const checkRoute = async () => {
      try {
        setLoading(true);
        
        // Extract the slug from the full path
        const slug = fullPath.split('/')[0]; // Get first segment after the route
        
        // Load all locations from API
        const response = await publicAPI.getLocations();
        const locations = response.data.locations || [];
        
        // Check if the slug exists in our locations
        const locationExists = locations.find(loc => loc.slug === slug);
        
        if (locationExists) {
          setValidSlug(slug);
        } else {
          setValidSlug(null);
        }
        
      } catch (error) {
        console.error('Error checking route:', error);
        setValidSlug(null);
      } finally {
        setLoading(false);
      }
    };

    if (fullPath) {
      checkRoute();
    } else {
      setLoading(false);
    }
  }, [fullPath]);

  if (loading) {
    return (
      <div className="bg-black text-white min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-white"></div>
      </div>
    );
  }

  if (validSlug) {
    return <DynamicCityPage slug={validSlug} />;
  }

  // If route not found, redirect to 404 page
  return <Navigate to="/404" replace />;
};

export default DynamicRouteHandler;